/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundSyncForwardIcon16Regular = forwardRef('ArrowRoundSyncForwardIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.46 2.778a5.25 5.25 0 0 1 5.16 2.727h-1.885a.75.75 0 0 0 0 1.5h3.515a.75.75 0 0 0 .75-.75V2.128a.75.75 0 0 0-1.5 0v1.958A6.75 6.75 0 0 0 1.544 6.031a.75.75 0 1 0 1.435.437 5.25 5.25 0 0 1 4.48-3.69Z" }),
        React.createElement("path", { d: "M2.5 13.872a.75.75 0 0 1-1.5 0V9.745a.75.75 0 0 1 .75-.75h3.516a.75.75 0 1 1 0 1.5H3.38l.019.033a5.25 5.25 0 0 0 9.621-.992.75.75 0 0 1 1.435.439A6.75 6.75 0 0 1 2.5 11.914v1.958Z" })));
});
